import { Logtail } from '@logtail/browser'

const logger = new Logtail(process.env.FRONTEND_LOGS_SOURCE_TOKEN, {
  endpoint: 'https://in.logs.betterstack.com',
  sendLogsToConsoleOutput: process.env.RAILS_ENV === 'development',
})

export default logger
